import React, { useState } from 'react';

import { AlertActivity } from '../../api';
import EmbededFrame from '../../components/EmbededFrame';
import { formatToLocalTime } from '../../libs/libDate';
import { titleCase } from '../../libs/libString';

interface AlertActivityDisplayProps {
  alertId: string;
  activity: AlertActivity;
}

const AlertActivityDisplay: React.FC<AlertActivityDisplayProps> = (props) => {
  const { alertId, activity } = props;
  const [expanded, setExpanded] = useState(false);
  return <>
    <div className='max-w-full border border-background-darker mb-3'>
      <div className='py-2 px-1'>
        <p>{formatToLocalTime(activity.createdDate)}</p>
        {activity.sender != null && <p>
          <span className='font-bold'>From: {activity.sender}</span>
        </p>}
        <div className='max-w-full overflow-hidden whitespace-nowrap overflow-ellipsis'>{activity.subject}</div>
        {expanded && <div><EmbededFrame id={alertId} entity='alerts' activityId={activity.id} htmlContent={activity.body} className='w-full h-full test-1' /></div>}
      </div>
      <a onClick={() => setExpanded(!expanded)} className='cursor-pointer'>
        <div className='w-full hover:bg-hover py-1 px-2 flex'>
          <div className='opacity-50'>{expanded ? 'Show Less' : 'Show More'}</div>
          <div className='ml-auto opacity-50'><i className={`bi ${expanded ? 'bi-caret-up-square' : 'bi-caret-down-square'}`} /></div>
        </div>
      </a>
    </div>
  </>;
};

export default AlertActivityDisplay;